var _style, _path, _path2, _path3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 733 500",
    style: {
      enableBackground: "new 0 0 733 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#ECB006;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M461.2,41.3c0,112,0,222.5,0,333.7c6.7,0,12.2,0,18.4,0c0-111.8,0-222.5,0-333.7 C473,41.3,467.7,41.3,461.2,41.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M429.6,283.6c-106.2,0-212.5,0-320.4,0c-13,30.6-26.1,61.2-39.7,93.3c9.1,0,15.5,0,23.1,0l29.8-70.1h147.1 c0,0,0,0,0.1,0.1l30.8,69.8c25.6,0,50.2,0,77,0c-11.5-27.3-22.6-53.4-34.4-81.3c23.9,0,45.3,0,68.4,0c0,26.9,0,53,0,79.8 c7.5,0,13.5,0,19.1,0c0.1-0.2,0.2-0.4,0.2-0.5V286C430.4,285,430,284.1,429.6,283.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.6,41.8v204.4h-89.1c-30-69.5-59.4-137.6-88.7-205.2h-72C113,152.7,65.3,264,17,376.9h23.3 c17-39.7,34-79.4,51.3-119.9h339.1c0-0.1,0.1-0.2,0.1-0.2v-215H410.6z M154.7,235.5l41.7-95.8l41.7,95.8H154.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M104.4,451.8v-36.9l-0.7-5.7h33.8c5.9,0,10.3,1.1,13.1,3.5c3,2.4,4.4,5.9,4.4,10.9v13.8c0,5-1.5,8.7-4.4,11.1 c-3,2.2-7.4,3.5-13.3,3.5h-32.9V451.8z M118.7,441.9h16.6c3.7,0,5.5-1.7,5.7-5.2v-12.6c0-1.5-0.4-2.6-1.3-3.5 c-0.7-0.9-2.2-1.5-4.4-1.5h-16.6L118.7,441.9L118.7,441.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M157.8,451.8l21.2-42.6h18.8l21.2,42.6h-15.7l-3.5-7.8H177l-4.1,7.8H157.8z M181,434.1H196l-7-15.5h-0.7 L181,434.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M226.3,451.8v-36.9l-0.7-5.7h13.3l20.5,20.9l2.8,3.1h0.7v-24h14v42.6h-12.2l-20.9-21l-2.8-3.3h-0.9v24.4 L226.3,451.8L226.3,451.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M302.5,451.8c-5.2,0-8.9-1.1-11.3-3.3c-2.4-2.2-3.5-5.9-3.5-11.1v-13.3c0-5.2,1.3-9,3.9-11.4 c2.6-2.4,6.3-3.5,10.9-3.5h21.2c3.3,0,5.9,0.2,7.8,0.6c1.8,0.4,2.6,0.7,2.6,1.1l-2.2,9c-1.3-0.2-3.5-0.4-7-0.6 c-3.5-0.2-7.9-0.2-13.3-0.2h-3.7c-2.2,0-3.9,0.4-4.6,1.3c-0.7,0.9-1.1,2.2-1.1,3.9v12.4c0,1.7,0.4,3,1.1,3.9 c0.7,0.9,2.2,1.3,4.8,1.3h3c7,0,12.2,0,15.9-0.2c3.7-0.2,5.7-0.4,6.5-0.6l4.4,7.8c0,0.2-0.6,0.6-1.5,1.1c-0.9,0.6-2.6,0.9-5,1.3 c-2.4,0.4-5.5,0.6-9.8,0.6L302.5,451.8L302.5,451.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M344.7,451.8v-42.6h46.7v10H359v6.1h24v10.2h-24v6.8h31.4l4.4,9.2c0,0.2-0.7,0.4-2,0.6 c-1.3,0.2-3.5,0.2-6.8,0.2h-41.2V451.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M431.9,451.8c-5.2,0-8.9-1.1-11.3-3.3c-2.4-2.2-3.5-5.9-3.5-11.1v-13.3c0-5.2,1.3-9,3.9-11.4 c2.6-2.4,6.3-3.5,10.9-3.5h21.2c3.3,0,5.9,0.2,7.8,0.6c1.8,0.4,2.6,0.7,2.6,1.1l-2.2,9c-1.3-0.2-3.5-0.4-7-0.6 c-3.5-0.2-7.9-0.2-13.3-0.2h-3.7c-2.2,0-3.9,0.4-4.6,1.3c-0.7,0.9-1.1,2.2-1.1,3.9v12.4c0,1.7,0.4,3,1.1,3.9 c0.7,0.9,2.2,1.3,4.8,1.3h3c7,0,12.2,0,15.9-0.2s5.7-0.4,6.5-0.6l4.4,7.8c0,0.2-0.6,0.6-1.5,1.1c-0.9,0.6-2.6,0.9-5,1.3 c-2.4,0.4-5.5,0.6-9.8,0.6L431.9,451.8L431.9,451.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M474.1,451.8v-42.6h14v16.2h22.5v-16.2h14v42.6h-14v-16.6h-22.5v16.6H474.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M531,451.8l21.2-42.6H571l21.2,42.6h-15.7l-3.5-7.8h-22.9l-4.1,7.8H531z M554.2,434.1h14.9l-7-15.5h-0.7 L554.2,434.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M645.9,452.6c-1.8,0-4.1-0.4-6.5-0.9c-2.4-0.6-4.8-2-7-4.4l-3.1-3.1c-1.5-1.5-2.8-2.6-4.2-3.5 c-1.3-0.9-2.8-1.7-4.6-2c-1.7-0.4-3.9-0.7-6.5-0.7h-0.6v14h-14.2v-36.9l-0.7-5.9h33.6c3.1,0,5.5,0.4,7.6,1.1c1.8,0.7,3.3,1.7,4.4,3 c1.1,1.3,1.8,2.6,2.2,4.2c0.4,1.5,0.6,3.1,0.6,4.8v1.3c0,3-0.7,5.5-2.2,7.8c-1.5,2.2-3.9,3.9-7,5c1.3,0.7,2.4,1.5,3.5,2.2 c1.1,0.7,2.4,1.5,3.7,2.4c1.7,0.9,3.1,1.7,4.4,2s2.6,0.7,3.5,0.7c0.9,0.2,1.5,0.2,1.7,0.2l-2.2,8.1c-0.6,0.2-1.5,0.4-2.6,0.6 C648.5,452.4,647.2,452.6,645.9,452.6z M622.1,428.2c1.3,0,2.4,0,3.5,0s2.2-0.2,3.1-0.2c1.7-0.2,2.8-0.7,3.3-1.5 c0.6-0.9,0.9-1.8,0.9-3.1v-0.7c0-1.1-0.4-1.8-0.9-2.4c-0.6-0.6-1.7-0.9-3.3-0.9h-15.1v8.9c1.3,0,2.6,0.2,4.1,0.2 C619.2,428.2,620.7,428.2,622.1,428.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M671,451.8V419h-17.3v-10h48.9v10h-17.5v32.9H671z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "71.9,405 64.4,409.1 70.7,415.4 75.5,408.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.1,448.8l-7.9,17.8c0.2,0.7,0.4,1.4,0.6,2l7.3-6V448.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "75.5,408.7 70.7,415.4 72.4,417.1 83.9,417.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "44.8,448.3 52.9,450.6 52.9,445.6 44.8,435.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "83.9,417.1 72.4,417.1 78.5,423.2 84.8,417.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "62.2,395.4 56.1,400.8 62.1,406.8 65.4,398.5  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,471.2c0,2.3,1.8,4.1,4.1,4.1s4.1-1.8,4.1-4.1v-9.7l-8.2,4.2V471.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.1,443.2l-8.2-1.2v22.3c0,0.8,0.1,1.6,0.2,2.3l7.9-17.8L39.1,443.2L39.1,443.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "65.4,398.5 62.1,406.8 64.4,409.1 71.9,405  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.8,445.3c0.9-0.9,1.7-1.8,2.3-2.8l-6.5-5c-0.4,0.7-1,1.5-1.6,2.1l-8.1,8.1h11.5L86.8,445.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.8,419.9l-2-2l-6.3,5.2l2.5,2.5c0.9,0.9,1.6,2,2.1,3.1l8.8,1.4C91.4,426.5,89.7,422.8,86.8,419.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "72.9,447.6 69.9,450.6 77.3,454.8 84.5,447.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17,465.7 25.2,461.5 25.2,459 17,455.4  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M60.7,459.8c-1.6,1.6-1.6,4.2,0,5.8c1.6,1.6,4.2,1.6,5.8,0l7.3-7.3H62.3L60.7,459.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.8,451.1l8,15c0.1-0.6,0.2-1.2,0.2-1.9v-13.7l-8.2-2.3V451.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "62.3,458.2 73.8,458.2 77.3,454.8 69.9,450.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.8,464.3c0,1.6-1.3,2.9-2.9,2.9c-1.6,0-2.9-1.3-2.9-2.9v-1.6l-7.3,6c1.7,3.9,5.6,6.7,10.1,6.7 c4.4,0,8.2-2.6,10-6.4l-7.1-6.5v1.8H44.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.8,462.5l7.1,6.5c0.4-0.9,0.7-1.8,0.9-2.8l-8-15V462.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M91.9,430.2l-8.8-1.4c0.8,1.8,1,3.8,0.6,5.6l8.3-1.5C92,432,92,431.1,91.9,430.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92,432.9l-8.3,1.5c-0.2,1-0.6,2-1.1,3l6.5,5C91,439.6,92,436.2,92,432.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "39.1,433 30.9,439.6 30.9,441.9 39.1,443.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "44.8,417.8 52.9,427.7 52.9,419 44.8,416.2  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M28,390.4c-1.5,0-3,0.3-4.4,0.9l2.2,8.2c0.5-0.6,1.3-1,2.1-1c0.9,0,1.6,0.4,2.2,1l5.3-6.2 C33.5,391.5,30.9,390.4,28,390.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.8,401.6v14.6L53,419v-5.1l-8-15C44.8,399.7,44.8,400.6,44.8,401.6z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "39.1,429.4 30.9,422.2 30.9,439.6 39.1,433  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M17,401.4v3.3l8.2,0.7v-4.1c0-0.7,0.3-1.4,0.7-1.9l-2.2-8.2C19.8,393,17,396.9,17,401.4z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "39.1,410 30.9,403.6 30.9,418.5 39.1,413.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "39.1,413.2 30.9,418.5 30.9,422.2 39.1,429.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "44.8,433 52.9,433.7 52.9,427.7 44.8,417.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.1,401.4c0-3.2-1.4-6.1-3.5-8.1l-5.3,6.2c0.4,0.5,0.7,1.1,0.7,1.9v2.1l8.2,6.5v-8.6H39.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M44.9,398.9l8,15v-12.3c0-0.1,0-0.3,0-0.4l-7.5-4.5C45.2,397.4,45,398.1,44.9,398.9z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17,432.1 25.2,430.8 25.2,428.8 17,425.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17,437 25.2,444.2 25.2,430.8 17,432.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17,407.2 25.2,414.4 25.2,405.5 17,404.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17,450.2 25.2,447.6 25.2,444.2 17,437  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M61.5,394.7c-5.2-5.2-9.3-4.6-11.4-3.7c-1.5,0.6-3.7,2.1-4.8,5.8l7.5,4.5c0-1.4,0.3-2.2,0.4-2.6 c0.4,0.2,1.2,0.6,2.4,1.8l0.3,0.3l6.1-5.4L61.5,394.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17,455.4 25.2,459 25.2,447.6 17,450.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17,420 25.2,416.7 25.2,414.4 17,407.2  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "44.8,435.1 52.9,445.6 52.9,433.7 44.8,433  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "17,425.5 25.2,428.8 25.2,416.7 17,420  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.117ee84b86744183b323302c7adf5a3d.svg";
export { ForwardRef as ReactComponent };